import { styled } from "@mui/material";

export const DeclineTextWrapperStyled = styled("div")({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '24px',
  'p': {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '16px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
  },
});
